<template>
  <div>
    <v-layout wrap v-if="participants.length > 0">
      <v-container>
        <v-layout wrap>
          <v-flex sm2>
            <p class="title primary--text">Inicio</p>
          </v-flex>
          <v-flex
            sm10
            class="d-flex flex-row-reverse"
            style="text-align: right"
          >
            <Export />

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="dialogAddParticipant = true"
                  v-on="on"
                  class="primary primary mr-2"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Añadir Empleado</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="copyQuestionnaireURL"
                  v-on="on"
                  class="primary primary mr-2"
                >
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Enlace al Cuestionario</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="getParticipants"
                  v-on="on"
                  class="primary primary mr-2"
                >
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </template>
              <span>Actualizar</span>
            </v-tooltip>

            <div style="padding-right: 10px; font-size: 13px">
              <span
                >Empleados: {{ participants.length }} /
                {{ userData.maxParticipants }}</span
              >
              <br />
              <span
                >Cuestionarios Completados:
                {{ participantsResponded.length }}</span
              >
            </div>
          </v-flex>
        </v-layout>
        <v-flex sm12>
          <v-text-field
            v-model="searchString"
            solo
            label="Buscar empleados"
            prepend-inner-icon="mdi-magnify"
            background-color="grey lighten-3"
          ></v-text-field>
        </v-flex>

        <Users
          @update="
            getParticipants();
            toSnackbar();
          "
          :search="search"
          :userData="userData"
        />

        <!-- <v-flex sm12>
          <v-layout wrap>
            <v-flex sm1 pl-4>
              <v-checkbox
                v-model="activeAll"
                @change="activeChild"
                color="primary"
              ></v-checkbox>
            </v-flex>
            <v-flex sm1>Número</v-flex>
            <v-flex sm2>Nombre del Empleado</v-flex>
            <v-flex sm2>Correo electrónico</v-flex>
            <v-flex sm2>Puesto</v-flex>
            <v-flex sm2>Clave de acceso</v-flex>
            <v-flex sm1 class="d-flex justify-end" mr-9>-->
        <!-- <v-icon @click="printAll" class="mr-2">mdi-printer</v-icon> -->
        <!--
              <v-icon @click="dialogDelete = true" class="mr-2"
                >mdi-close</v-icon
              >
            </v-flex>
          </v-layout>
        </v-flex>

        <div style="height: 39vh; overflow-y: auto; overflow-x: hidden">
          <v-flex>
            <v-list flat>
              <v-list-item-group v-model="settings" multiple>
                <v-list-item
                  v-for="participant in search"
                  :key="'participant_' + participant.idParticipant"
                >
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="deep-purple accent-4"
                        @click="toggle"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <ItemParticipant
                        :participant="participant"
                        @update="getParticipants, toSnackbar"
                      ></ItemParticipant>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-flex>
        </div> -->
      </v-container>
    </v-layout>

    <v-layout wrap v-else-if="loadedParticipants">
      <v-flex offset-md3 sm6 class="text-center">
        <v-icon color="grey" size="128">mdi-folder-plus-outline</v-icon>
      </v-flex>
      <v-flex offset-md3 sm6>
        <v-layout wrap>
          <v-flex class="text-center display-1 grey--text">
            <p>
              Selecciona el archivo csv que contiene la lista de tus empleados
            </p>
          </v-flex>
          <v-flex sm12 style="text-align: center">
            <v-form ref="form">
              <v-file-input
                v-model="file"
                :loading="isLoading"
                :rules="rules"
                label="Selecciona tu archivo .csv"
                accept=".csv"
              ></v-file-input>
            </v-form>
            <v-btn @click="upload">Subir</v-btn>
            <br />
            <br />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Ventana para crear empleados -->
    <v-dialog v-model="dialogAddParticipant" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Añadir empleados</v-card-title
        >

        <v-form ref="formCreate" @submit.prevent="addParticipant">
          <v-container>
            <v-layout wrap>
              <v-flex sm12>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      counter="8"
                      max="99999999"
                      v-model="work"
                      label="Número"
                      :rules="requiredRule"
                      @keypress="numberOnly($event.target)"
                      type="number"
                      onkeydown="javascript: return event.keyCode == 69 ? false : true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="position"
                      label="Puesto"
                      :rules="requiredRule"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="name"
                      label="Nombre"
                      :rules="requiredRule"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-switch
                      v-model="showEmailField"
                      label="Correo Electrónico"
                    ></v-switch>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-if="showEmailField"
                      v-model="email"
                      label="Correo Electrónico"
                      :rules="emailRule"
                      type="email"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogAddParticipant = false"
              >cancelar</v-btn
            >
            <v-btn color="primary" text type="submit">Añadir</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Ventana para eliminar todos -->
    <v-dialog v-model="dialogDelete" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Eliminar empleados</v-card-title
        >

        <v-card-text class="title"
          >¿Estás seguro de eliminar a estos empleados?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogDelete = false"
            >cancelar</v-btn
          >
          <v-btn color="primary" text @click="deleteAll">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ventana de mensajes al crear -->
    <v-dialog v-model="dialogInfo" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Empleados guardados</v-card-title
        >

        <v-card-text class="title">
          <p v-if="works.length > 0" class="title">
            Los siguientes números se repiten
          </p>
          <p v-for="(w, index) in works" :key="index">{{ w }}</p>
          <p v-if="notNumbers.length > 0" class="title">
            Los siguientes números no se consideran como números validos
          </p>
          <p v-for="(notNumber, index) in notNumbers" :key="index + 'a'">
            {{ notNumber }}
          </p>
          <p v-if="large.length > 0" class="title">
            Los siguientes números son mayor a 8 caracteres
          </p>
          <p v-for="(l, index) in large" :key="index">{{ l }}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogInfo = false"
            >aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" top right>
      {{ message }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import ItemParticipant from "@/components/client/ItemParticipant";

import Export from "@/components/client/Export";
import Print from "@/components/client/Print";
import Users from "@/components/client/Users";

import axios from "axios";
import { mapState } from "vuex";
export default {
  components: {
    ItemParticipant,
    Export,
    Users,
    Print,
  },
  data() {
    return {
      rules: [
        (value) => !!value || "Este campo es obligatorio",
        (value) =>
          !value || value.size < 5000000 || "El tamaño debe ser menor a 5 MB!",
      ],
      emailRule: [
        (v) => !!v || "Este campo es obligatorio",
        (v) => /.+@.+\..+/.test(v) || "El correo debe ser valido",
      ],
      requiredRule: [(v) => !!v || "Este campo es obligatorio"],
      file: null,
      isLoading: false,
      searchString: "",
      snackbar: false,
      participants: [],
      settings: [],
      activeAll: false,
      timeOut: 3000,
      dialogDelete: false,
      message: "",
      dialogAddParticipant: false,
      work: null,
      works: [],
      notNumbers: [],
      large: [],
      dialogInfo: false,
      name: "",
      email: "",
      position: "",
      showEmailField: false,
      host: process.env.VUE_APP_HOST,
      loadedParticipants: false,
    };
  },
  methods: {
    toSnackbar(e) {
      console.log(e);
    },
    numberOnly(event) {
      console.log(event);

      event.value = event.value.replace(/[^0-9]/g, "");
    },
    copyQuestionnaireURL() {
      this.copyText(
        `http://guiats.human-express.com/#/questionnaire/${this.userData.id}/login`,
        "Enlace de acceso copiado al portapapeles"
      );
    },
    copyText(textToCopy, textToShow) {
      var aux = document.createElement("input");

      aux.setAttribute("value", textToCopy);

      document.body.appendChild(aux);

      aux.select();

      document.execCommand("copy");

      document.body.removeChild(aux);

      this.message = textToShow;
      this.snackbar = true;
    },
    upload() {
      if (this.$refs.form.validate()) {
        const fd = new FormData();
        fd.append("csv", this.file, this.file.name);
        this.isLoading = true;
        let idUser = sessionStorage.getItem("authorization");
        fd.append("idUser", idUser);

        axios
          .post(this.host + "/participants/upload.php", fd, {
            onUploadProgress: (progressEvent) => {
              //console.log(progressEvent.loaded / progressEvent.total)
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.works = response.data.work;
              this.notNumbers = response.data.notNumbers;
              this.large = response.data.large;

              if (
                this.works.length > 0 ||
                this.notNumbers.length > 0 ||
                this.large.length > 0
              ) {
                this.dialogInfo = true;
              }
            }

            this.snackbar = true;
            this.message = response.data.message;
            this.file = null;
            this.isLoading = false;
            this.$refs.form.resetValidation();
            this.getParticipants();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    addParticipant() {
      if (this.$refs.formCreate.validate()) {
        let data = {
          name: this.name,
          work: this.work,
          email: this.email,
          position: this.position,
          idUser: sessionStorage.getItem("authorization"),
        };

        axios
          .post(
            this.host + "/participants/create.php",
            this.createFormData(data)
          )
          .then((response) => {
            this.snackbar = true;
            this.message = response.data.message;

            this.dialogAddParticipant = false;
            this.work = null;
            this.name = "";
            this.email = "";
            this.$refs.formCreate.resetValidation();
            this.getParticipants();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getParticipants() {
      let data = {
        idUser: sessionStorage.getItem("authorization"),
        personalData: true,
      };

      this.loadedParticipants = false;
      this.participants = [];

      axios
        .post(this.host + "/participants/read.php", this.createFormData(data))
        .then((response) => {
          this.participants = response.data.data;
          this.loadedParticipants = true;
          this.$emit("updateTotal", this.participants.length);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    activeChild() {
      if (!this.activeAll) {
        this.settings = [];
      } else {
        for (let i = 0; i < this.participants.length; i++) {
          this.settings.push(i);
        }
      }
    },
    printAll() {
      if (this.settings.length > 0) {
        //let data = []
        const fd = new FormData();
        for (let i = 0; i < this.settings.length; i++) {
          let participant = this.participants[this.settings[i]];
          fd.append("participants[]", participant.idParticipant);
        }

        axios
          .post(this.host + "/participants/printall.php", fd)
          .then((response) => {
            this.snackbar = true;
            this.message = response.data.message;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.message = "Debes seleccionar por lo menos un empleado";
        this.snackbar = true;
      }
    },
    deleteAll() {
      if (this.settings.length > 0) {
        const fd = new FormData();
        for (let i = 0; i < this.settings.length; i++) {
          let participant = this.participants[this.settings[i]];
          fd.append("participants[]", participant.idParticipant);
        }
        fd.append("idUser", sessionStorage.getItem("authorization"));

        axios
          .post(this.host + "/participants/deleteall.php", fd)
          .then((response) => {
            this.snackbar = true;
            this.message = response.data.message;
            this.settings = [];
            this.dialogDelete = false;
            this.getParticipants();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.message = "Debes seleccionar por lo menos un empleado";
        this.snackbar = true;
      }
    },
    download() {
      let data = {
        idUser: sessionStorage.getItem("authorization"),
      };

      axios({
        url: this.host + "/participants/download.php",
        method: "POST",
        responseType: "blob",
        data: this.createFormData(data),
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Empleados.csv");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    },
  },
  mounted() {
    this.getParticipants();
  },
  computed: {
    ...mapState(["userData"]),
    participantsResponded() {
      var users = this.participants.filter((participant) => {
        return participant.resolved;
      });
      return users;
    },
    search() {
      return this.participants.filter((user) => {
        let find = false;

        Object.keys(user).forEach((element) => {
          let elString = user[element] + "";

          if (
            elString.toLowerCase().includes(this.searchString.toLowerCase())
          ) {
            find = true;
          }
        });

        return find;
      });
    },
  },
};
</script>